import { userApi } from "api/TenantSlug/User/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import UserData = App.Data.UserData;

interface Args {
    roleId?: string;
}

export const useUserSelectOptions = ({ roleId }: Args = {}) => {
    const queryParams = {
        filter: {
            ...(roleId && {
                filter: {
                    "roles.id": roleId,
                },
            }),
            sort: "nickname",
        },
    };

    return useSelectOptions<UserData>({
        apiFunction: (payload) => userApi.index(payload),
        dataKey: "users",
        cacheKey: "user-select",
        queryParams,
        mapToOption: (user) => ({
            label: user.nickname ?? user.email ?? user.id,
            value: user.id ?? "",
        }),
    });
};
